import { fetchCards, selectedCards } from '@shared-core/features/backend'
import { useAppDispatch, useAppSelector } from '@shared-core/store'
import { useEffect } from 'react'

// Загружает карты только если их ещё нет; обновляются они опросами экранов.
export function useCards() {
  const dispatch = useAppDispatch()
  const cards = useAppSelector(selectedCards)

  useEffect(() => {
    if (!cards) void dispatch(fetchCards())
  }, [cards, dispatch])

  return cards
}
